import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { WorkspaceUserForTableDTO } from './types'

export const WORKSPACE_USER_FOR_TABLE_FRAGMENT: TypedDocumentNode<WorkspaceUserForTableDTO> = gql`
  fragment WorkspaceUserForTableFragment on User {
    currentWorkspaceRole
    email
    firstName
    id
    lastName
    status
    updatedAt
  }
`
